module.exports = __webpack_public_path__ + "static/media/check_blue.8b0b70f3.svg";